<template>
  <div class="container-fluid mt-4">
    <h4 class="text-primary">Gestionar Roles y Permisos</h4>

    <!-- Filtros de Roles y Permisos -->
    <div class="row mb-4">
      <div class="col-md-4">
        <label for="selectRole" class="form-label fw-bold">Seleccionar Rol</label>
        <select v-model="roleSeleccionado" class="form-select">
          <option :value="null">Todos los Roles</option>
          <option v-for="role in rolesFiltrados" :key="role.id" :value="role.id">
            {{ role.nombre }}
          </option>
        </select>
      </div>
      <div class="col-md-4">
        <label for="searchRole" class="form-label fw-bold">Buscar Rol</label>
        <input
          v-model="searchRole"
          type="text"
          class="form-control"
          placeholder="Buscar rol por nombre..."
        />
      </div>
    </div>

    <div class="row mb-4">
      <div class="col-md-4">
        <label for="selectPermiso" class="form-label fw-bold">Seleccionar Permiso</label>
        <select v-model="permisoSeleccionado" class="form-select">
          <option :value="null">Todos los Permisos</option>
          <option v-for="permiso in permisosDisponiblesFiltrados" :key="permiso.id" :value="permiso.id">
            {{ permiso.nombre }}
          </option>
        </select>

        <button class="btn btn-primary mt-3" @click="vincularPermiso">
          <font-awesome-icon icon="link" class="me-1" /> Vincular Permiso
        </button>
      </div>
      <div class="col-md-4">
        <label for="searchPermiso" class="form-label
          fw-bold">Buscar Permiso</label>
        <input
          v-model="searchPermiso"
          type="text"
          class="form-control"
          placeholder="Buscar permiso por nombre..."
        />

       
      </div>
    </div>

    <!-- Tabla de Roles y Permisos -->
    <div class="table-responsive">
      <table class="table table-bordered table-hover">
        <thead class="table-primary text-center">
          <tr>
            <th>Rol</th>
            <th>Permiso</th>
            <th>Acciones</th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="entry in paginatedPermisos"
            :key="`${entry.role.id}-${entry.permiso.id}`"
          >
            <td>{{ entry.role.nombre }}</td>
            <td>{{ entry.permiso.nombre }}</td>
            <td class="text-center">
              <button
                class="btn btn-danger btn-sm"
                @click="$emit('desvincular-permiso', entry.role.id, entry.permiso.id)"
              >
                <font-awesome-icon icon="unlink" class="me-1" /> Desvincular
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- Paginación -->
    <div class="d-flex justify-content-between align-items-center mt-3">
      <button
        class="btn btn-secondary"
        :disabled="currentPage === 1"
        @click="currentPage--"
      >
        Anterior
      </button>
      <span>Página {{ currentPage }} de {{ totalPages }}</span>
      <button
        class="btn btn-secondary"
        :disabled="currentPage === totalPages"
        @click="currentPage++"
      >
        Siguiente
      </button>
    </div>
  </div>
</template>

<script>
export default {
  props: ["roles", "permisos"],
  data() {
    return {
      searchRole: "",
      searchPermiso: "",
      roleSeleccionado: null,
      permisoSeleccionado: null,
      currentPage: 1,
      itemsPerPage: 10,
    };
  },
  computed: {
    rolesFiltrados() {
      return this.roles.filter((role) =>
        role.nombre.toLowerCase().includes(this.searchRole.toLowerCase())
      );
    },
    permisosDisponiblesFiltrados() {
      return this.permisosDisponibles.filter((permiso) =>
        permiso.nombre.toLowerCase().includes(this.searchPermiso.toLowerCase())
      );
    },
    permisosRolSeleccionado() {
      if (!this.roleSeleccionado) return [];
      const role = this.roles.find((r) => r.id === this.roleSeleccionado);
      return role?.usr_role_permisos.map((rp) => rp.permiso) || [];
    },
    permisosDisponibles() {
      return this.permisos.filter(
        (permiso) => !this.permisosRolSeleccionado.some((p) => p.id === permiso.id)
      );
    },
    permisosFiltradosPorTexto() {
      const allEntries = this.roles.flatMap((role) =>
        (role.usr_role_permisos || []).map((rp) => ({
          role,
          permiso: rp.permiso,
        }))
      );

      return allEntries.filter(
        (entry) =>
          (!this.roleSeleccionado || entry.role.id === this.roleSeleccionado) &&
          entry.role.nombre.toLowerCase().includes(this.searchRole.toLowerCase()) &&
          entry.permiso.nombre.toLowerCase().includes(this.searchPermiso.toLowerCase())
      );
    },
    totalPages() {
      return Math.ceil(this.permisosFiltradosPorTexto.length / this.itemsPerPage);
    },
    paginatedPermisos() {
      const start = (this.currentPage - 1) * this.itemsPerPage;
      return this.permisosFiltradosPorTexto.slice(start, start + this.itemsPerPage);
    },
  },
  methods: {
    vincularPermiso() {
      if (this.roleSeleccionado && this.permisoSeleccionado) {
        this.$emit("vincular-permiso", this.roleSeleccionado, this.permisoSeleccionado);
        this.permisoSeleccionado = null;
      }
    },
  },
};
</script>

<style scoped>
.container-fluid {
  max-width: 1200px;
}

h4 {
  font-weight: bold;
  margin-bottom: 1rem;
}

.table-hover tbody tr:hover {
  background-color: #f8f9fa;
}

.table-bordered {
  border: 1px solid #dee2e6;
}

.table-primary {
  background-color: #cfe2ff;
}

.btn {
  margin: 0 5px;
}

.text-primary {
  color: var(--app-primary);
}

.form-select {
  width: 100%;
}

.table-responsive {
  max-height: 500px;
  overflow-y: auto;
}
</style>
